function groupAccountsByCountry(accounts) {
  var countryCodes = [];
  var accountsGroupByCountry = [];
  accounts.forEach(function (account, index) {
    if (!countryCodes.includes(account.country)) {
      countryCodes.push(account.country);
      accountsGroupByCountry.push({
        country: account.country,
        countryName: account.countryName,
        countryIcon: account.countryIcon,
        accounts: [{
          accountName: account.accountName,
          accountId: account.accountId,
          accountCode: account.accountCode,
          entityId: account.entityId,
          fatherAccount: account.fatherAccount
        }]
      });
    } else {
      var countryPosition = countryCodes.indexOf(account.country);
      accountsGroupByCountry[countryPosition].accounts.push({
        accountName: account.accountName,
        accountId: account.accountId,
        accountCode: account.accountCode,
        entityId: account.entityId,
        fatherAccount: account.fatherAccount
      });
    }
  });
  return accountsGroupByCountry;
}

export { groupAccountsByCountry as default };
